import { metrics } from '@atlassian/browser-metrics';
import {
	CORE_PROJECT,
	type ProjectType,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { ADD_PEOPLE_READY_MARK_KEY } from '../../model/constants';

export const addPeopleTransitionMetric = metrics.interaction({
	key: 'project-settings-apps.add-people-dialog',
	timings: [
		{ key: 'timeToLoad', endMark: ADD_PEOPLE_READY_MARK_KEY },
		// @ts-expect-error - TS2322 - Type '{ key: string; }' is not assignable to type 'Timing'.
		{ key: 'readyToInteract' },
	],
});

export const isSoftwareProject = (projectType: ProjectType) => projectType === SOFTWARE_PROJECT;
export const isJwmProject = (projectType: ProjectType) => projectType === CORE_PROJECT;
export const isJsmProject = (projectType: ProjectType) => projectType === SERVICE_DESK_PROJECT;

export const isReferrerNPLEPage = () => {
	const params: URLSearchParams = new URLSearchParams(window.location.search);
	const isReferrerAvailable = params.has('referrer', 'servicedesk-getting-started-page');
	if (isReferrerAvailable) {
		const isInviteUsersForNPLEEnabled = expValEquals(
			'invite_users_via_nple',
			'cohort',
			'variation',
		);
		return isInviteUsersForNPLEEnabled;
	}
	return false;
};
